<template lang="pug">
md-layout(md-flex="100")
  .md-headline Upload Video
  md-layout
    md-layout(md-flex="90", md-flex-small="80")
      md-input-container(
        :class="{ 'md-input-invalid': formSubmitted && validations.fileUploaded.$invalid }"
      )
        label Select file to upload
        md-file#input-video(
          v-model="fileName",
          accept="video/*,.mkv",
          @selected="onFileSelected",
          :disabled="uploadDisabled"
        )
        span.md-error(v-if="!validName") The video file name should only contain letters and numbers
        span.md-error(v-else-if="!validFormat") You must select a valid video (the valid ones are: MOV, MP4, WEBM, AVI, WMV, MKV)
        span.md-error(
          v-else-if="formSubmitted && !validations.fileUploaded.required"
        ) You must select a video and click to upload it
    md-layout(md-flex="10", md-flex-small="20", md-align="center")
      .uploader
        md-button#upload-video.md-icon-button.md-fab(
          @click="upload",
          :class="{ 'md-primary': done }",
          :disabled="done"
        )
          md-icon(
            v-if="!done && !uploading",
            md-iconset="fa fa-cloud-upload-alt"
          )
          md-icon(v-if="done", md-iconset="fa fa-check")
          span.uploading(v-if="!done && uploading") % {{ progress }}
        md-theme(md-name="blue", v-if="progress > 0 && !done")
          md-spinner(:md-size="74", :md-stroke="2.2", :md-progress="progress")
      md-button.md-primary.cancel-button(
        @click="cancelUpload",
        v-if="uploading"
      )
        span(v-if="uploading") Cancel
      span.centered(v-if="!uploading && file && !done")
        | Click to upload
</template>

<script>
import uploadService from '../../services/uploadService';
import { validVideoFormat } from '../../common/utils/formatValidation';

export default {
  props: {
    required: {
      type: Boolean,
      default: false
    },
    validations: {
      type: Object,
      required: true
    },
    formSubmitted: {
      type: Boolean,
      required: true
    }
  },
  data() {
    return {
      fileName: '',
      file: null,
      progress: 0,
      done: false,
      uploading: false,
      validFormat: true,
      validName: true,
      cancel: null,
    };
  },
  computed: {
    uploadDisabled() {
      return this.uploading;
    }
  },

  mounted(){
    window.addEventListener('beforeunload', this.onBeforeUnload);
  },

  beforeDestroy() {
    window.removeEventListener('beforeunload', this.onBeforeUnload);
  },

  methods: {
    onBeforeUnload() {
      if (this.uploading) {
        this.cancelUpload()
      }
    },
    onFileSelected(files) {
      this.validFormat = validVideoFormat(files[0].name);

      if (!this.validFormat) {
        this.file = null;
        return
      }

      const fileName = (files[0].name.match(/.*\./)[0]).replace(/[^a-zA-Z0-9_•-]/g, '');
      this.validName = fileName.trim() !== '';

      if (!this.validName) {
        this.file = null;
        return
      }
      const updatedFile = new File( [...files], fileName, {
        type: files[0].type,
        lastModified: files[0].lastModified,
        lastModifiedDate: files[0].lastModifiedDate,
        size: files[0].size
      });

      this.$emit('videoName', updatedFile.name);
      this.file = updatedFile;

      document.getElementById('input-video').onchange = (() => {
        const video = document.createElement('video');
        video.preload = 'metadata';

        video.onloadedmetadata = () => {
          this.$emit('videoDuration', video.duration);
        }

        video.src = URL.createObjectURL(updatedFile);
      })();
      this.done = false;
    },
    cancelUpload() {
      this.done = false;
      this.cancel()
    },
    async upload() {
      if (!this.file) {
        this.validFormat = false;
        this.formSubmitted = true;
        return;
      }
      if (!this.uploadDisabled) {
        this.uploading = true;
        this.$emit('videoUploading', this.file.type);
        try {
          const url = await uploadService.uploadVideo(this.file, this);
          this.done = true;
          const mimeType = this.file.type;
          this.$emit('uploadSuccess', { url, mimeType });
        } catch (error) {
          this.progress = 0;
          if (this.cancel != null) {
            this.$emit('uploadCancel');
          } else {
            this.$emit('uploadFailed');
          }
        } finally {
          this.progress = 0;
          this.uploading = false;
        }
      }
  }
  }
};
</script>

<style lang="scss" scoped>
.md-headline {
  width: 100%;
}

.uploader {
  width: 56px;
  height: 56px;
  position: relative;

  .md-fab {
    margin: 0;
  }

  .md-spinner {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}

.cancel-button {
  background: #ff000096;
  color: #ffffffde !important;
  font-weight: 900;
  border-radius: 29px;
  font-size: 12px;
}

.md-invalid {
  color: #ff5722;
  display: block;
  left: 0px;
  height: 20px;
  position: absolute;
  bottom: -22px;
  font-size: 12px;
}

.centered {
  position: absolute;
  margin-top: 55px;
}</style>



// WEBPACK FOOTER //
// src/shared-components/upload/VideoUploader.vue